import {LEGAL} from './legal-content'

// Thin helpers around the generated legal kit (legal-content.js / legal-render.js, copied unchanged from
// legal-sweep-mx/out/exsportia). Nothing in here writes legal text: it only picks the right kit entry.

export type LegalKind = 'deletion' | 'privacy' | 'terms'
export type LegalLang = 'en' | 'th'

export const LEGAL_KINDS: LegalKind[] = ['privacy', 'terms', 'deletion']

/** The kit exists in English and Thai. Every other app language (ru, my, heb, ua) shows the English kit. */
export const toLegalLang = (language?: string | null): LegalLang => (language === 'th' ? 'th' : 'en')

export const legalPath = (kind: LegalKind, lang: LegalLang): string =>
  lang === 'th' ? `${LEGAL.paths.thPrefix}${LEGAL.paths[kind]}` : LEGAL.paths[kind]

/** Old addresses that the old Facebook apps and other documents still point to: they render the same page. */
export const LEGAL_ALIASES: {kind: LegalKind; path: string}[] = [
  ...LEGAL.aliases.privacy.map((path) => ({kind: 'privacy' as const, path})),
  ...LEGAL.aliases.terms.map((path) => ({kind: 'terms' as const, path})),
]

export const legalFooter = (lang: LegalLang) => LEGAL.footer[lang]
export const legalStrings = (lang: LegalLang) => LEGAL.strings[lang]

/** The kit writes the Thai year in the Buddhist era (2569). */
export const legalYear = (lang: LegalLang, year: number): number => (lang === 'th' ? year + 543 : year)
